import React from 'react'
import { Link } from 'react-router-dom'
import './SocialButtons.css'

const SocialButtons = () => {
  return (
    <>
 

    
     
<div className="social">
    <ul className="socialList">
        
      
        <li className="socialItem">
            <Link to='https://www.linkedin.com/in/abhishekmaurya149/' target='_blank' className="socialLink" href="#">
                <span className="socialButton socialButton_linkedin"> 
                    <i className="social_Icon fa-brands fa-linkedin"></i>
                </span>
            </Link>
        </li>

        <li className="socialItem">
            <Link to='https://github.com/abhishekmaurya149' target='_blank' className="socialLink" href="#">
                <span className="socialButton socialButton_github">
                    <i className="social_Icon fab fa-github"></i>
                </span>
            </Link>
        </li>

        <li className="socialItem">
            <Link to='https://twitter.com/mauryaj123123'  target='_blank' className="socialLink" href="#">
                <span className="socialButton socialButton_twitter">
                    <i className="social_Icon fab fa-twitter"></i> 
                </span>
            </Link>
        </li>
    </ul>
</div>


    </>
  )
}

export default SocialButtons
